import React, { useMemo } from "react";
import ReactApexChart from "react-apexcharts";

const ChannelPreferences = ({ data }) => {
  const chartData = useMemo(() => {
    if (!data || data.length === 0) return { series: [], labels: [] };

    return {
      series: data.map((item) => parseFloat(item.averageWeight)),
      labels: data.map((item) => item.channel),
    };
  }, [data]);

  const options = {
    chart: {
      type: "donut",
    },
    labels: chartData.labels,
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
          labels: {
            show: true,
            total: {
              show: true,
              label: "Total",
              formatter: () =>
                chartData.series.reduce((a, b) => a + b, 0).toFixed(0),
            },
          },
        },
      },
    },
    colors: ["#91B9A8", "#7398C3", "#F0D5A6"],
  };

  return (
    <div className="flex items-center">
      <div className="w-[220px]">
        <ReactApexChart
          options={options}
          series={chartData.series}
          type="donut"
          height={215}
        />
      </div>

      <div>
        {chartData.labels.map((label, i) => (
          <div key={label} className="flex items-center gap-1">
            <span
              className="w-3 h-3 rounded-full"
              style={{
                backgroundColor: options.colors[i % options.colors.length],
              }}
            ></span>
            <span className="text-gray-600 text-sm">{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChannelPreferences;
